<template>
	<div>
		<sub-header bizCd="01"/>
		 <div class="sub_visual sub11">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">홍보영상</div>
                    <div class="comment">지금 바로, 에듀윌과 함께 해야 하는 이유를 영상으로 만나보세요.</div>
                </div>
            </div>
        </div>
		<div class="contents aos-all">
			<div class="container">
				                <div class="sec">
                    <div class="sub_tit">에듀윌 <br class="m_hidden">홍보 영상</div>
                    <div class="con rv-wrap">
                      <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                           video-url="https://www.youtube.com/embed/jJtr672UxKM">
                        <div class="rv-img">
                          <img alt="" src="//pds.eduwill.net/board/board229/00420250825151842.png " class="">
                          <div class="mask">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                          </div>
                        </div>
                        <div class="rv-text">
                          우즈베키스탄 학생들이 에듀윌에 온 이유는?
                        </div>

                      </div>
                      <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                           video-url="https://www.youtube.com/embed/pNfxap75-Rs">
                        <div class="rv-img">
                          <img alt="" src="//pds.eduwill.net/board/board229/00320250825152131.png" class="">
                          <div class="mask">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                          </div>
                        </div>
                        <div class="rv-text">
                          푸드테크 자격증 시대...에듀윌이 앞장선다!
                        </div>

                      </div>
                      <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                           video-url="//www.youtube.com/embed/GiPFuBn9euA?si=1qBg9mwZXxrwXC5I">
                        <div class="rv-img">
                          <img alt="" src="//pds.eduwill.net/board/board229/00220250825151842.png" class="">
                          <div class="mask">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                          </div>
                        </div>
                        <div class="rv-text">
                          💥에듀윌 손해평가사 런칭💥│오직 1월 14일까지만!│사전예약으로 최대 83% 할인중!│홍태우 교수, 박승희 교수
                        </div>

                      </div>

                      <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                           video-url="//www.youtube.com/embed/WEa5naZNepM?si=Nnpf3C3pQj91DuXo">
                        <div class="rv-img">
                          <img alt="" src="//pds.eduwill.net/board/board229/00120250825151842.png" class="">
                          <div class="mask">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                          </div>
                        </div>
                        <div class="rv-text">
                          💥12월 30일, 에듀윌 대기/수질환경기사 런칭💥│비전공자도 단숨에 합격, 적중 환경 이찬범│전망 좋은 직업│환경 자격증 추천
                        </div>

                      </div>
                      <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                           video-url="https://www.youtube.com/embed/QiymuWgJ3h8?amp;autoplay=1&amp;playlist=QiymuWgJ3h8&amp;loop=1">
                        <div class="rv-img">
                          <img alt="" src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/thumb_01.png" class="">
                          <div class="mask">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                          </div>
                        </div>
                        <div class="rv-text">
                          [에듀윌 B2B] 성공을 만드는 변화의 시작, <br>
                          에듀윌 B2B와 함께하세요!
                        </div>

                      </div>
                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                            video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20211231/kt_pr.mp4">
                            <div class="rv-img">
                                <img alt="" src="//img.eduwill.net/resources/b2b/dev/images/img_rv_01.png" class="">
                                <div class="mask">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                </div>
                            </div>
                            <div class="rv-text">
                                에듀윌-KT 내일설계휴직제도<br>
                                온라인 교육 사업 홍보 영상
                            </div>

                        </div>

                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                            video-url="https://www.youtube.com/embed/ektW-CoCU3I?amp;autoplay=1&amp;playlist=ektW-CoCU3I&amp;loop=1">
                            <div class="rv-img">
                                <img alt="" src="//img.eduwill.net/resources/b2b/dev/images/img_rv_02.png">
                                <div class="mask">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                </div>
                            </div>
                            <div class="rv-text">
                                에듀윌-서울시 교육복지사업 <br>
                                ‘서울런‘ 홍보 영상
                            </div>
                        </div>
                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                            video-url="https://www.youtube.com/embed/SdNfuh5PcuQ?amp;autoplay=1&amp;playlist=SdNfuh5PcuQ&amp;loop=1">
                            <div class="rv-img">
                                <img alt=""
                                    src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/SdNfuh5PcuQ-maxresdefault.jpg">
                                <div class="mask">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                </div>
                            </div>
                            <div class="rv-text">
                                에듀윌-국립공주대<br>재학생 교육 지원 업무 협약 영상
                            </div>
                        </div>
                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                            video-url="https://www.youtube.com/embed/Nt9__u3iIP0?amp;autoplay=1&amp;playlist=Nt9__u3iIP0&amp;loop=1">
                            <div class="rv-img">
                                <img alt=""
                                    src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/Nt9__u3iIP0-maxresdefault.jpg">
                                <div class="mask">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                </div>
                            </div>
                            <div class="rv-text">
                                에듀윌 ESG 평가 '우수' 교육업계 최고 등급 달성
                            </div>
                        </div>
<!--                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"-->
<!--                            video-url="https://www.youtube.com/embed/OrbUvwhql5E?amp;autoplay=1&amp;playlist=OrbUvwhql5E&amp;loop=1">-->
<!--                            <div class="rv-img">-->
<!--                                <img alt=""-->
<!--                                    src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/OrbUvwhql5E-maxresdefault.jpg">-->
<!--                                <div class="mask">-->
<!--                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="rv-text">-->
<!--                                빡센 토익은 그만, 이제는 쉬운 토익 공식-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                            video-url="https://www.youtube.com/embed/VVCdp5bU77o?amp;autoplay=1&amp;playlist=VVCdp5bU77o&amp;loop=1">
                            <div class="rv-img">
                                <img alt=""
                                    src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/VVCdp5bU77o-maxresdefault.jpg">
                                <div class="mask">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                </div>
                            </div>
                            <div class="rv-text">
                                취업에 유리한 국가자격증이 있다고?｜에듀윌 IT자격증
                            </div>
                        </div>
<!--                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"-->
<!--                            video-url="https://www.youtube.com/embed/12xMJDTOMS4?amp;autoplay=1&amp;playlist=12xMJDTOMS4&amp;loop=1">-->
<!--                            <div class="rv-img">-->
<!--                                <img alt=""-->
<!--                                    src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/12xMJDTOMS4-maxresdefault.jpg">-->
<!--                                <div class="mask">-->
<!--                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="rv-text">-->
<!--                                공인중개사 합격자수 1위 에듀윌! 합격수기만 2만 9천 건 돌파-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="slide-item btn-play btn-popup" pop-name="videoPop"
                            video-url="https://www.youtube.com/embed/Vb3MJl5duiQ?amp;autoplay=1&amp;playlist=Vb3MJl5duiQ&amp;loop=1">
                            <div class="rv-img">
                                <img alt=""
                                    src="//img.eduwill.net/resources/b2b/dev/images/youtubeThumbnail/Vb3MJl5duiQ-maxresdefault.jpg">
                                <div class="mask">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                </div>
                            </div>
                            <div class="rv-text">
                                취업 프리패스를 원한다면, 에듀윌 전산세무회계
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sec none-padding">
                    <div class="sub_tit">직무·과정별 <br class="m_hidden">추천 영상</div>
                    <div class="con">
                        <div class="txt line02">주부, 은퇴 설계 직장인 등 다양한 분야의 에듀윌 합격생들이 전하는 <br class="m_hidden">에듀윌을 선택해야 하는
                            이유를 만나보세요.</div>
                        <div class="video-list grid">
                            <div class="col item-1">
                                <strong class="ttl">기술자격</strong>
                                <ul class="pc840hidden">
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://www.youtube.com/embed/QjdBWLbHfZw?amp;autoplay=1&amp;playlist=QjdBWLbHfZw&amp;loop=1">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_01.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://www.youtube.com/embed/UI1_9rjEf00?amp;autoplay=1&amp;playlist=UI1_9rjEf00&amp;loop=1">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_02.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/sample/conte/Y/YYM-PR-LSH.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_03.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/sample/conte/Q/QQF_PR_LHJ.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_04.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://www.youtube.com/embed/INhxgeHhHgc?amp;autoplay=1&amp;playlist=INhxgeHhHgc&amp;loop=1">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_05.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://www.youtube.com/embed/vOtkzXUoIV0?amp;autoplay=1&amp;playlist=vOtkzXUoIV0&amp;loop=1">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_06.jpg" />
                                    </li>

                                </ul>
                                <div class="responsive_slider mobile840hidden">
                                    <div class="swiper-container img-role" id="">
                                        <div class="swiper-wrapper">

                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://www.youtube.com/embed/QjdBWLbHfZw?amp;autoplay=1&amp;playlist=QjdBWLbHfZw&amp;loop=1">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_01.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://www.youtube.com/embed/UI1_9rjEf00?amp;autoplay=1&amp;playlist=UI1_9rjEf00&amp;loop=1">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_02.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/sample/conte/Y/YYM-PR-LSH.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_03.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/sample/conte/Q/QQF_PR_LHJ.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_04.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://www.youtube.com/embed/INhxgeHhHgc?amp;autoplay=1&amp;playlist=INhxgeHhHgc&amp;loop=1">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_05.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://www.youtube.com/embed/vOtkzXUoIV0?amp;autoplay=1&amp;playlist=vOtkzXUoIV0&amp;loop=1">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_06.jpg" />
                                            </div>
                                        </div>

                                        <div class="swiper-pagination"></div>
                                        <div class="vi-button swiper-button-next"></div>
                                        <div class="vi-button swiper-button-prev"></div>

                                    </div>
                                </div>
                            </div>
                            <div class="col item-2">
                                <strong class="ttl">전문자격</strong>
                                <ul class="pc840hidden">
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210421/house_interview1.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_07.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210219/land_interview_ccs.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_08.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210507/well_jhs.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_09.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210514/K_KimHoyong.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_10.jpg" />
                                    </li>
                                    <li class="slide-item btn-play btn-popup" pop-name="videoPop"
                                        video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/sample/conte/A/AAE-CONTE-LJH.mp4">
                                        <img alt=""
                                            src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_12.jpg" />
                                    </li>
                                </ul>
                                <div class="responsive_slider mobile840hidden">
                                    <div class="swiper-container img-role" id="">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210421/house_interview1.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_07.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210219/land_interview_ccs.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_08.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210507/well_jhs.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_09.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/20210514/K_KimHoyong.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_10.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://www.youtube.com/embed/OJP4LpeZeSY?amp;autoplay=1&amp;playlist=OJP4LpeZeSY&amp;loop=1">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_11.jpg" />
                                            </div>
                                            <div class="swiper-slide slide-item btn-play btn-popup" pop-name="videoPop"
                                                video-url="https://pmp.eduwill.net/eduwillpmp/eduwill/flv/sample/conte/A/AAE-CONTE-LJH.mp4">
                                                <img alt=""
                                                    src="//img.eduwill.net/resources/partner/ktcareers/images/thmb_12.jpg" />
                                            </div>
                                        </div>

                                        <div class="swiper-pagination"></div>
                                        <div class="vi-button swiper-button-next"></div>
                                        <div class="vi-button swiper-button-prev"></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                
                </div>
			</div>
		
		</div>
		</div>
		    <!-- 비디오 팝업 -->
    <div class="popup video-popup" id="videoPop">
        <a class="btn-close popClose" href="javascript:;">팝업닫기</a>
        <div class="video-cont"></div>
    </div>
		<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
<style scoped>

</style>
